import React from "react";
import logoGeel from "../assets/img/Voltics_logo-geel.png";
import useActiveSection from "../hooks/useActiveSection";

const SECTIONS = [
  { id: "about", label: "Over ons" },
  { id: "services", label: "Diensten" },
  { id: "portfolio", label: "Projecten" },
  { id: "contact", label: "Contact" },
];

export const Navigation = () => {
  const active = useActiveSection(SECTIONS.map((s) => s.id));

  return (
    <nav id="menu" className="navbar navbar-default navbar-fixed-top">
      <div className="container">
        <div className="navbar-header">
          {/* Hamburger menu for mobile */}
          <button
            type="button"
            className="navbar-toggle collapsed"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>

          {/* Logo */}
          <a className="navbar-brand logo-link" href="/#page-top">
            <img src={logoGeel} alt="logo voltics" style={{ width: "8em" }} />
          </a>
        </div>

        {/* Navigation links */}
        <div
          className="collapse navbar-collapse"
          id="bs-example-navbar-collapse-1"
        >
          <ul className="nav navbar-nav navbar-right text-black">
            {SECTIONS.map((s) => (
              <li key={s.id} className={active === s.id ? "active" : ""}>
                <a href={`/#${s.id}`} className="page-scroll">
                  {s.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};
